// frontend/src/Place.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingScreen from '../../components/utilities/LoadingScreen';

function Place() {
    const { uuid } = useParams();
    const navigate = useNavigate();
    const isLoading = true;
    useEffect(() => {
        // Fetch the route from the backend
        fetch(`/api/place/${uuid}`)
            .then((response) => {
                if (response.redirected) {
                    navigate(response.url.replace(window.location.origin, ''), { replace: true });
                } else {
                    throw new Error('Place not found');
                }
            })
            .catch((error) => {
                console.error(error);
                navigate('/404', { replace: true }); // Navigate to a 404 page if needed
            });
    }, [uuid, navigate]);

    return <LoadingScreen isLoading={true} message="Fetching place ..." />;
}

export default Place;
